import {combineReducers} from "redux";
import {connectRouter} from "connected-react-router";
import path from "./path";
import product from "./product";
import condition from "./condition";
import designs from "./designs";
import sides from "./sides";
import realism from "./realism";
import message from "./message";
import pictures from "./pictures";
import uploader from "./uploader";
import authenticityToken from "./authenticity-token";
import modals from "./modals";
import undoRedo from "./undo-redo";
import crops from "./crops";
import isShownProducts from "./is-shown-products";
import forAllSides from "./for-all-sides";
import isPichshop from "./is-pichshop";
import figures from "./figures";
import emoji from "./emoji";
import cliparts from "./cliparts";
import letterings from "./letterings";
import initialVariants from "./initial-variants";
import user from "./user";
import visionHubState from "./visionhub-state";
import onPlatform from "./onPlatform";
import shutterStockEnabled from "./shutter-stock-enabled";
import mobileApp from "./mobile-app";
import drawControlPopup from "./drawControlPopup";
import selectionMode from "./selectionMode";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    path,
    authenticityToken,
    product,
    condition,
    designs,
    sides,
    realism,
    message,
    pictures,
    uploader,
    modals,
    undoRedo,
    crops,
    isShownProducts,
    forAllSides,
    isPichshop,
    figures,
    emoji,
    cliparts,
    letterings,
    initialVariants,
    user,
    visionHubState,
    onPlatform,
    shutterStockEnabled,
    mobileApp,
    drawControlPopup,
    currency: (state = {}) => state,
    selectionMode,
    isMobile: (state = false) => state,
  });

export default createRootReducer;
